<template>
    <div id="complete">
        <Header title="已完成" :show-back="true" class="header"></Header>
        <div class="content">
            <div class="info">
                <img src="../../assets/img/complete/logo.png" alt="" class="info_logo"/>
                <p class="info_type">订单已完成</p>
                <ul>
                    <li>
                        <span>买方</span>
                        <span>{{orderObj.real_name}}</span>
                    </li>
                    <li>
                        <span>总额</span>
                        <span>{{orderObj.num * orderObj.price}} RMB</span>
                    </li>
                    <li>
                        <span>数量</span>
                        <span>{{orderObj.num}}</span>
                    </li>
                    <li>
                        <span>备注码</span>
                        <span>{{orderObj.remark}}</span>
                    </li>
                    <li>
                        <span>广告ID：{{orderObj.id}}</span>
                        <span>订单号：{{orderObj.adid}}</span>
                    </li>
                    <li>
                        <span>下单时间</span>
                        <span>{{formatDate(orderObj.addtime,2)}}</span>
                    </li>

                </ul>
            </div>
            <!--评价-->
            <div class="evaluate">
                <div class="title">
                    <span></span>
                    评价商家
                </div>
                <div class="startWrap" style="margin-bottom: 20px;">
                    <span class="text">信用度：</span>
                    <van-rate v-model="creditValue" color="#1FC26D" void-color="#B5C1CB"
                              void-icon="star" gutter="15px"/>
                </div>
                <div class="startWrap">
                    <span class="text">及时度：</span>
                    <van-rate v-model="timeValue" color="#1FC26D" void-color="#B5C1CB"
                              void-icon="star" gutter="15px"/>
                </div>
            </div>
            <button @click="submit">评价商家</button>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        name: "complete",
        components: {
            Header
        },
        data() {
            return {
                creditValue: 0,
                timeValue: 0,
                orderObj: {},
            }
        },
        created() {
            this.getOrderData();
        },
        methods: {
            getOrderData() {
                let id = this.$route.query.id;
                this.ajax.post('appapi/c2c/order', {id: id}).then((res) => {
                    if (res.data.code === 1) {
                        this.orderObj = res.data.data.info;
                    }
                })
            },
            submit() {
                let id = this.$route.query.id;
                let obj = {
                    oid: id,
                    ranka: this.creditValue,
                    rankb: this.timeValue,
                };
                this.ajax.post('appapi/c2c/rank', obj).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.$router.replace({path: "/myC2c"});
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    #complete {
        .content {
            padding: 20px 40px 40px;

            .info {
                height: 923px;
                padding-top: 63px;
                text-align: center;
                background: url("../../assets/img/complete/bg.png") no-repeat center/cover;

                .info_logo {
                    width: 94px;
                    height: 94px;
                    margin-bottom: 22px;
                }

                .info_type {
                    margin-bottom: 138px;
                    font-size: 36px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                }

                ul {
                    li {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 40px;
                        margin-bottom: 50px;

                        &:last-child {
                            margin-bottom: 60px;
                        }

                        span {
                            &:first-child {
                                font-size: 26px;
                                color: rgba(111, 120, 139, 1);
                            }

                            &:last-child {
                                font-size: 28px;
                                font-weight: bold;
                                color: rgba(51, 51, 51, 1);
                            }
                        }
                    }
                }
            }

            .evaluate {
                margin-bottom: 97px;

                .title {
                    display: flex;
                    align-items: center;
                    margin-bottom: 65px;
                    font-size: 30px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);

                    span {
                        display: inline-block;
                        width: 7px;
                        height: 36px;
                        margin-right: 11px;
                        background: rgba(47, 207, 122, 1);
                        border-radius: 4px;
                    }
                }

                .startWrap {
                    display: flex;
                    align-items: center;

                    .text {
                        margin-right: 30px;
                        font-size: 30px;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                    }
                }
            }

            button {
                width: 100%;
                height: 86px;
                font-size: 30px;
                font-weight: bold;
                color: #fff;
                background: rgba(31, 194, 109, 1);
                border-radius: 10px;
            }
        }
    }
</style>
